module.exports = __webpack_public_path__ + "img/loading.3d6075f2.gif";